import React, {  useState } from "react";
import { Link } from "react-router-dom";

const servicesContent = [
  {
    title: "Ingénierie  ",
    title2: "financière",
    description:
      "L'ingénierie financière consiste à utiliser des techniques mathématiques pour résoudre des problèmes financiers. L’immobilier, comme tous les autres produits financiers sur les marchés, est un écosystème à plusieurs variables qui doit constamment être ajusté à travers le temps pour rester dans un sain équilibre et performer. Chaque membre de notre équipe est formé dans l’art et la science de la finance avancée, que ce soit par le biais d’études pour obtenir le titre de <span> Chartered Financial Analyst </span> ou bien par une formation avancée en science actuarielle. ",
  },
  {
    title: "Appariement des flux  ",
    title2: "monétaires",
    description:
      "L’appariement de  l’<span>Actif </span> et du <span> Passif </span> est une des approches mathématiques la plus utilisée par les Actuaires et est au cœur de notre expertise quand vient le temps de bâtir des systèmes financiers qui se tiennent solides à travers les différents horizons d’investissement. <br/><br/> Il est primordial de s’assurer que les flux monétaires provenant de l’<span>actif</span> et du <span>passif</span> d’un portefeuille immobilier sont bien appariés à travers le temps. Que ce soit les travaux d’entretien sur le parc immobilier à travers le temps, l’échéance de refinancement des dettes adossées au portefeuille, ou toutes autre obligation financière découlant de la détention d’immeubles locatifs devant être réglées a un moment précis dans le temps, nous sommes maîtres dans l’art d’implémenter les bons mécanismes et structures financières dans votre portefeuille afin de limiter le risque de <span> mismatch </span> entre vos entrées d’argent et vos obligations financières futures.",
  },
  {
    title: "Financement",
    title2: "",
    description:
      "Les dettes et l’effet de levier étant des éléments <span>cruciaux </span> de la gestion de portefeuille en investissement immobilier, notre équipe vous assiste dans la façon de structurer et gérer les financements adossés à vos actifs immobiliers. Notre connaissance <span>approfondie </span> des différents programmes de la SCHL ainsi que de la tarification des produits bancaires sur le marché vous assure de sélectionner la bonne structure de financement pour maximiser la performance de votre portefeuille et gérer le risque de liquidité à court, moyen et long terme. <br/> <br/> Bien que chaque projet ait ses particularités et nuances qui doivent privilégier une solution de financement sur mesure, notre équipe tiens également compte de la composition globale du portefeuille client dans ses recommandations. Ce portrait complet qui est pleinement considéré lorsque nous structurons des financements pour nos clients nous <span> différencie </span> du marché actuel qui considère souvent les projets comme des vases clos indépendants les uns des autres.",
  },
  {
    title: "Négociation",
    // title2: "partenariats",
    description:
      "Avec notre connaissance approfondie des structures financières d’acquisition pouvant mener à des ententes <span> gagnants-gagnants </span>, nous pouvons vous assister lors de négociations pour vos acquisitions en cours ou même avec les différents partenaires potentiels qui cherchent à travailler avec vous. Au-delà des chiffres, nous comprenons également tous les intangibles liés à une transaction immobilière et son impact dans votre stratégie de croissance stratégique. <br/><br/> Nous structurons des transactions pour des investisseurs immobiliers depuis plusieurs années et sommes régulièrement exposés à une variété de structures qui prennent place dans le marché transactionnel d’aujourd’hui.  Notre <span>expertise</span> issue du milieu de la Finance dans toutes sortes de produits financiers hors immobilier nous donne également un regard frais et différent qui mène plus souvent qu’autrement à des solutions créatives et innovantes à appliquer dans vos négociations.",
  },
  {
    title: "Présentation des  ",
    title2: "résultats",
    description:
      "Présenter des résultats est un art que nous avons cultivé depuis le début de nos carrières respectives. Bien équilibrer le détail avec le résumé. Savoir bien <span> vulgariser </span> selon les audiences tout en étant capable de faire référence à des concepts plus <span> sophistiqués </span> dans nos explications lorsque la situation le demande. <br/> <br/> Nous comprenons bien comment <span>nuancer </span> le discours selon l’objectif visé par nos clients et l’audience à laquelle nous nous adressons pour expliquer les résultats d’un projet ou portefeuille immobilier.  Notre professionnalisme et notre intégrité nous guide également pour toujours donner un portrait complet et nuancé des chiffres. <br/><br/>Donner l’heure juste à nos clients et leurs partenaires, avec le bon équilibre dans l’explication des différentes hypothèses utilisées et les scénarios modélisés, c’est aussi ça  l’<span>expertise </span> Beatimo à votre service.  ",
  },
  {
    title: "Stratégie",
    title2: "",
    description:
      "Notre expertise en gestion de portefeuille étant déjà bien établie, nous savons également comment bien définir et assister dans l’exécution de la meilleure <span> stratégie </span> pour faire croître votre portefeuille d’actifs immobiliers tout en gérant les risques de manière adéquate. Notre compréhension approfondie de toutes les opérations cruciales au bon fonctionnement d’une société immobilière combinée à notre capacité de bien lire et comprendre les différentes nuances du <span> profil d’investisseur </span> de nos clients font de nous l’allié de choix pour bien déterminer les prochaines actions à poser afin d’atteindre vos objectifs à court, moyen et long terme.  ",
  },
  {
    title: "Partenariats  ",
    title2: "",
    description:
      "Après avoir structuré les produits financiers les plus complexes existants sur le marché, nous avons pendant des années exploré les différentes applications possibles dans l’investissement immobilier. Nous sommes également constamment exposés aux nouvelles idées dans le marché par notre implication dans la gestion de portefeuille de centaines d’investisseurs immobilier actifs qui ont plusieurs partenariats différents et uniques dans leur modèle d’affaires. <br/><br/> Les partenariats étant très similaire à tout autre système financier qui se doit d’être équilibré, notre expertise en produits à revenus fixes ainsi que notre compréhension des projets immobiliers de tous horizons est votre garantie d’excellence lorsque nous travaillons à structurer vos nouveaux partenariats ou même revisiter vos partenariats existants afin d’optimiser pour le bien de tous la croissance future de votre société immobilière.  ",
  },
  {
    title: "Achat par   ",
    title2: "actions",
    description:
      "Bien que l’assistance additionnelle d’experts en fiscalité et d’avocats soit souvent requise dans des dossiers d’achat par actions, notre firme excelle dans l’optimisation de la structure financière adossée à ce type de transaction. Encore une fois, notre capacité à bien comprendre les nuances du projet ou portefeuille spécifique sous-jacent à l’entreprise que nos clients cherchent à acquérir nous place comme partenaire de choix pour structurer les achats par actions. <br/><br/>Plusieurs parties prenantes étant liées à l’analyse et l’exécution de ce type de transaction, que ce soient les vendeurs, les acheteurs, les partenaires financiers, en plus des différents professionnels et intervenants, notre capacité à bien comprendre toutes les facettes et enjeux financiers liés aux achats par actions nous place souvent au centre même de l’action. Notre expertise à bien équilibrer les intérêts de chacun dans des environnements complexes a déjà été démontrée dans plusieurs dossiers clients alors que cette méthode d’acquisition dans le marché immobilier prend chaque année de plus en plus d’ampleur.  ",
  },
  
  // Add similar objects for other services as needed
];

const ProposeService = () => {
  const [selectedService, setSelectedService] = useState(null);

  const handleServiceClick = (index) => {
    setSelectedService(servicesContent[index]);
    openService();
  };

  const openService = () => {
    const sidenav = document.getElementById("mySidenav");
    sidenav.style.width = "50%";
    sidenav.style.padding = "30px";
    sidenav.classList.add("open");
  };

  const closeService = () => {
    const sidenav = document.getElementById("mySidenav");
    sidenav.style.width = "0";
    sidenav.style.padding = "0";
    sidenav.classList.remove("open");
    setSelectedService(null);
  };

  return (
    <>
      <section className="nos-services-section nos-services-orange-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="nos-services-left">
                <h5>
                  <img src="assets/image/nos-services-icon.png" alt="Propose-Service-img" /> Notre
                  expertise
                </h5>
                <h1>
                  Une <span> expertise </span> approfondie en investissement
                  <span> immobilier. </span>
                </h1>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="nos-services-right">
                <ul>
                  {servicesContent.map((service, index) => (
                    <li key={index} onClick={() => handleServiceClick(index)}>
                      <div>
                        <span>{`0${index + 1}`}</span>
                        <p>{service.title}{service.title2}</p>
                      </div>
                      <img src="assets/image/arrow-right.png" alt="service-section-img" />
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div id="mySidenav" className="sidenav">
        <Link to="#" className="closebtn" onClick={closeService}>
          <svg
            width={47}
            height={47}
            viewBox="0 0 47 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x={46}
              y={46}
              width="45.5"
              height="45.5"
              rx="22.75"
              transform="rotate(-180 46 46)"
              fill="#007367"
            />
            <rect
              x={46}
              y={46}
              width="45.5"
              height="45.5"
              rx="22.75"
              transform="rotate(-180 46 46)"
              stroke="#007367"
            />
            <path
              d="M19.2807 28.2057L18.2891 27.2141L22.2557 23.2474L18.2891 19.2807L19.2807 18.2891L23.2474 22.2557L27.2141 18.2891L28.2057 19.2807L24.2391 23.2474L28.2057 27.2141L27.2141 28.2057L23.2474 24.2391L19.2807 28.2057Z"
              fill="white"
            />
          </svg>
        </Link>
        {selectedService && (
          <>
            <div className="sidebar-top">
              <h1>
                {selectedService.title} <br /> <span>{selectedService.title2}</span>
              </h1>
            </div>
            <div className="sidebar-inner">
              <h5>
                <svg
                    width={16}
                    height={13}
                    viewBox="0 0 16 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      id="Vector"
                      d="M9.91451 12.4138H0.55399C0.2539 12.4138 0 12.1714 0 11.8598V0.710264C0 0.410174 0.242358 0.15625 0.55399 0.15625H9.91451C10.0646 0.15625 10.2031 0.213961 10.3069 0.317839L15.8355 5.84642C16.0548 6.06572 16.0548 6.41198 15.8355 6.61973L10.3069 12.2407C10.2031 12.3445 10.0646 12.4022 9.91451 12.4022V12.4138Z"
                      fill="#007367"
                    />
                  </svg>
                  Description
                </h5>
              <p dangerouslySetInnerHTML={{ __html: selectedService.description }}></p>
              {/* Other content such as video, advantages, process, etc. */}
              {/* <div className="side-bar-video">
                <video id="myVideo" controls>
                  <source src="assets/video/side-video.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <button id="playButton">
                  <svg width={60} height={61} viewBox="0 0 60 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_b_4890_1219)">
                      <circle cx={30} cy="30.2812" r={30} fill="white" fillOpacity="0.7" />
                    </g>
                    <path fillRule="evenodd" clipRule="evenodd" d="M36.8457 29.7554C37.4394 30.1513 37.4394 31.0237 36.8457 31.4195L27.0485 37.951C26.3839 38.3941 25.4937 37.9177 25.4937 37.119L25.4937 24.056C25.4937 23.2573 26.3839 22.7809 27.0484 23.224L36.8457 29.7554Z" fill="#007367" />
                    <defs>
                      <filter id="filter0_b_4890_1219" x={-20} y="-19.7188" width={100} height={100} filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity={0} result="BackgroundImageFix" />
                        <feGaussianBlur in="BackgroundImageFix" stdDeviation={10} />
                        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_4890_1219" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_4890_1219" result="shape" />
                      </filter>
                    </defs>
                  </svg>
                </button>
              </div>
              <div className="sidebar-bottom">
                <h5>
                  <svg width={16} height={13} viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path id="Vector" d="M9.91451 12.4138H0.55399C0.2539 12.4138 0 12.1714 0 11.8598V0.710264C0 0.410174 0.242358 0.15625 0.55399 0.15625H9.91451C10.0646 0.15625 10.2031 0.213961 10.3069 0.317839L15.8355 5.84642C16.0548 6.06572 16.0548 6.41198 15.8355 6.61973L10.3069 12.2407C10.2031 12.3445 10.0646 12.4022 9.91451 12.4022V12.4138Z" fill="#007367" />
                  </svg>
                  Avantages
                </h5>
                <h1>Maximisation des rendements</h1>
                <p>
                  Identification des opportunités d'investissement et de
                  croissance pour optimiser les rendements financiers
                </p>
                <h1>Gestion des risques</h1>
                <p>
                  Élaboration de stratégies de gestion des risques pour
                  protéger les actifs et minimiser les pertes potentielles
                </p>
              </div>
              <div className="sidebar-bottom">
                <h5>
                  <svg width={16} height={13} viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path id="Vector" d="M9.91451 12.4138H0.55399C0.2539 12.4138 0 12.1714 0 11.8598V0.710264C0 0.410174 0.242358 0.15625 0.55399 0.15625H9.91451C10.0646 0.15625 10.2031 0.213961 10.3069 0.317839L15.8355 5.84642C16.0548 6.06572 16.0548 6.41198 15.8355 6.61973L10.3069 12.2407C10.2031 12.3445 10.0646 12.4022 9.91451 12.4022V12.4138Z" fill="#007367" />
                  </svg>
                  Processus
                </h5>
                <h1>Analyse financière approfondie</h1>
                <p>
                  Évaluation des états financiers, des flux de trésorerie et
                  des besoins en capitaux pour comprendre la situation
                  actuelle
                </p>
                <h1>Élaboration de stratégies personnalisées</h1>
                <p>
                  Développement de plans financiers sur mesure en fonction des
                  objectifs spécifiques du client et de son appétence au
                  risque
                </p>
              </div> */}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ProposeService;
